// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-subscription-plans-page{
    position: relative;
    margin: 0px;
    padding: 0px;
    height: 100vh;
    box-sizing: border-box;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
}
/* #region Add subscription plan*/
.tenant-administrator-add-subscription-plan-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0,0.45);
}
.tenant-administrator-add-subscription-plan-main-container{
    position: relative;
    width: 32vw;
    opacity: 0;
    border-radius: 5px;
    background-color: white;
    transform: translateX(-100%);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    animation: tenant-administrator-add-subscription-plan-main-container-fade-in 1s ease-out forwards;
}
@keyframes tenant-administrator-add-subscription-plan-main-container-fade-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    80% {
        opacity: 1;
        transform: translateX(5%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.tenant-administrator-add-subscription-plan-header-container{
    color: white;
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-add-subscription-plan-header-container h1{
    margin: 0px;
    font-size: 22px;
    font-weight: 600;
}
.tenant-administrator-add-subscription-plan-header-container p{
    margin: 0px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.tenant-administrator-add-subscription-plan-body-container{
    position: relative;
    padding: 10px 25px;
    height: 670px;
    overflow: hidden;
}
.tenant-administrator-add-subscription-plan-navigation-bar{
    border-bottom: 1px solid rgb(219, 219, 219);
}
.tenant-administrator-add-subscription-plan-navigation-bar button{
    padding: 8px 20px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    color: rgb(70, 70, 70);
    background-color: transparent;
    border-bottom: 2px solid transparent;
    transition: border-bottom-color 0.25s ease;
}
.tenant-administrator-add-subscription-plan-navigation-bar button.active{
    color: rgba(155, 30, 30, 0.952);
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.tenant-administrator-add-subscription-plan-details-container,
.tenant-administrator-add-subscription-plan-visibility-container{
    opacity: 0;
    transform: translateX(-100%);
    transition: opacity 0.1s ease, transform 0.5s ease;
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0;
    pointer-events: none;
}
.tenant-administrator-add-subscription-plan-details-container.active,
.tenant-administrator-add-subscription-plan-visibility-container.active{
    opacity: 1;
    transform: translateX(0);
    position: relative;
    pointer-events: auto;
}
.tenant-administrator-add-subscription-plan-details-container.hidden,
.tenant-administrator-add-subscription-plan-visibility-container.hidden{
    opacity: 0;
    transform: translateX(100%);
    pointer-events: none;
}
.tenant-administrator-add-subscription-plan-details-container .components-container{
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-add-subscription-plan-details-container .components-container:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.tenant-administrator-add-subscription-plan-details-container .components-container p{
    margin: 0px;
    font-size: 12px;
}
.tenant-administrator-add-subscription-plan-details-container .components-container span{
    color: red;
}
.tenant-administrator-add-subscription-plan-details-container .components-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
}
.tenant-administrator-add-subscription-plan-details-container .components-container select{
    width: 100%;
    margin: 0px;
    border: none;
    outline: none;
    padding: 2px 0px;
    background-color: transparent;
}
.tenant-administrator-add-subscription-plan-details-container .deactivation-window-entry-container{
    display: grid;
    grid-template-columns: 2fr 1fr;
    margin-top: 2px;
    margin-right: 6px;
}
.tenant-administrator-add-subscription-plan-details-container .features-title-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
}
.tenant-administrator-add-subscription-plan-details-container .features-title-container h2{
    margin: 0px;
    font-size: 20px;
    font-weight: 600;
    color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-add-subscription-plan-details-container .features-title-container img{
    margin: 0px;
    height: 25px;
    cursor: pointer;
}
.tenant-administrator-add-subscription-plan-details-container .feature-containers{
    padding: 0px 15px;
    height: 20vh;
    overflow-y: auto;
}
.tenant-administrator-add-subscription-plan-details-container .features-empty-container{
    height: 20vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-add-subscription-plan-details-container .features-empty-container div{
    padding: 10px;
    border-radius: 10px;
    opacity: 0;
    transform: translateY(-10px);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    animation: tenant-administrator-add-subscription-features-empty-container-fade-in 1.55s ease forwards;
}
@keyframes tenant-administrator-add-subscription-features-empty-container-fade-in {
    from{
        opacity: 0;
        transform: translateY(-10px);
    }
    to{
        opacity: 1;
        transform: translateY(0px);
    }
}
.tenant-administrator-add-subscription-plan-details-container .features-empty-container div p{
    margin: 0px;
    font-size: 15px;
}
.tenant-administrator-add-subscription-plan-details-container .feature-container{
    display: flex;
    justify-content: space-between;
    margin: 10px 0px;
    padding: 6px 15px;
    border-radius: 4px;
    border: 1px solid rgb(197, 197, 197);
}
.tenant-administrator-add-subscription-plan-details-container .feature-container.empty{
    border: 1px solid red;
}
.tenant-administrator-add-subscription-plan-details-container .feature-container.empty:focus-within{
    border: 1px solid rgb(197, 197, 197);
}
.tenant-administrator-add-subscription-plan-details-container .feature-container p{
    margin: 0px;
}
.tenant-administrator-add-subscription-plan-details-container .feature-container input{
    width: 80%;
    outline: none;
    border: none;
}
.tenant-administrator-add-subscription-plan-details-container .feature-container img{
    height: 20px;
    cursor: pointer;
}
.tenant-administrator-add-subscription-plan-details-container .buttons-container{
    padding: 15px 0px;
    text-align: right;
}
.tenant-administrator-add-subscription-plan-details-container .cancel-add-subscription-button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-weight: 600;
    color: rgba(155, 30, 30, 0.952);
    background-color: transparent;
    transition: background-color 0.25s ease;
}
.tenant-administrator-add-subscription-plan-details-container .cancel-add-subscription-button:hover{
    background-color: rgb(238, 238, 238);
}
.tenant-administrator-add-subscription-plan-details-container .add-subscription-button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-selection-container{
    margin-top: 25px;
    display: flex;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-selection-container input{
    zoom: 1.5;
    cursor: pointer;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-selection-container p{
    font-size: 15px;
    margin-left: 10px;
    cursor: pointer;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container{
    max-height: 0;
    overflow: hidden;
    height: auto;
    margin-top: 12px;
    padding: 4px 20px;
    transition: max-height 1s ease-in-out, padding 1s ease-in-out;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container.active{
    max-height: 40vh;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header{
    margin-bottom: 28px;
    padding: 8px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(201, 201, 201);
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 600;
    color: rgb(43, 43, 43);
    text-align: center;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header button{
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: transparent;
    transition: background-color 0.25s ease;
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header button:hover{
    background-color: rgb(240, 240, 240);
}
.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header button img{
    height: 30px;
}
.tenant-administrator-add-subscription-plan-fetching-customers-container{
    width: 100%;
    height: 100%;
    text-align: center;
}
.tenant-administrator-add-subscription-plan-fetching-customers-container div{
    margin-top: 10%;
    width: 20px;
    height: 20px;
    display: inline-block;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: tenant-administrator-add-subscription-plan-fetching-customers-container-spinner 1s linear infinite;
}
@keyframes tenant-administrator-add-subscription-plan-fetching-customers-container-spinner {
    0% {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
}
.tenant-administrator-add-subscription-plan-fetching-customers-container p{
    margin: 4px 0px;
}
.tenant-administrator-add-subscription-plan-unselected-server-container,
.tenant-administrator-add-subscription-plan-unavailable-customers-container{
    height: 15vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
}
.tenant-administrator-new-plan-visibility-customers-table-container{
    height: 25vh;
    overflow: auto;
    margin-bottom: 20px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-new-plan-visibility-customers-table-container::-webkit-scrollbar{
    width: 5px;
}
.tenant-administrator-new-plan-visibility-customers-table-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0,0.3);
}
.tenant-administrator-new-plan-visibility-customers-table-container table{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}
.tenant-administrator-new-plan-visibility-customers-table-container table th,
.tenant-administrator-new-plan-visibility-customers-table-container table td{
    text-align: left;
    padding: 4px;
    padding-left: 20px;
    cursor: default;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-new-plan-visibility-customers-table-container table th{
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: white;
    border-bottom: 1px solid rgb(214, 214, 214);
}
.tenant-administrator-new-plan-visibility-customers-table-container table th:last-child,
.tenant-administrator-new-plan-visibility-customers-table-container table td:last-child{
    width: 10%;
}
.tenant-administrator-new-plan-visibility-customers-table-container table td img{
    height: 20px;
    margin-top: 2px;
    cursor: pointer;
}
.tenant-administrator-add-subscription-plan-customers-browser{
    position: absolute;
    top: 0;
    left: 0;
    width: 80%;
    height: 30vh;
    border-radius: 5px;
    background-color: rgb(250, 250, 250);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
}
.tenant-administrator-add-subscription-plan-customers-browser .header .main-header{
    padding: 4px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-add-subscription-plan-customers-browser .header .main-header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 600;
    color: rgb(51, 51, 51);
}
.tenant-administrator-add-subscription-plan-customers-browser .header .main-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 400;
}
.tenant-administrator-add-subscription-plan-customers-browser .header .minor-header{
    padding: 4px 16px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 150px 1fr;
    color: rgb(236, 236, 236);
    background-color: rgb(107, 126, 138);
}
.tenant-administrator-add-subscription-plan-customers-browser .header .minor-header p{
    margin: 0px;
}
.tenant-administrator-add-subscription-plan-customers-browser .header .minor-header .customers-title-paragraph{
    margin-left: 15px;
}
.tenant-administrator-add-subscription-plan-customers-browser .body{
    flex-grow: 1;
    display: grid;
    grid-template-columns: 150px 1fr;
    background-color: white;
    overflow: hidden;
}
.tenant-administrator-add-subscription-plan-customers-browser .body .servers-container{
    height: 100%;
    border-right: 2px solid rgb(218, 218, 218);
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-container{
    padding: 4px 10px;
    cursor: pointer;
    transition: background-color 0.25s ease;
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-container:hover{
    background-color: rgba(98, 115, 119, 0.425);
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container{
    height: 100%;
    overflow-y: auto;
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.3);
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p{
    margin: 0px;
    padding: 4px 10px;
    cursor: default;
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p:hover{
    background-color: rgba(98, 115, 119, 0.425);
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .server-customer-container{
    font-size: 15px;
    cursor: default;
    padding: 4px 10px;
    transition: background-color 0.45s ease;
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .server-customer-container:hover{
    background-color: rgba(98, 115, 119, 0.425);
}
.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .server-customer-container.selected-customer{
    background-color: rgba(74, 121, 74, 0.18)!important;
}
.tenant-administrator-add-subscription-plan-customers-browser .controls{
    padding: 10px 0px;
    background-color: transparent;
    text-align: right;
}
.tenant-administrator-add-subscription-plan-customers-browser .controls button{
    border: none;
    cursor: pointer;
    padding: 6px 16px;
    margin: 0px 10px;
    border-radius: 4px;
    color: rgb(236, 236, 236);
    background-color: rgb(107, 126, 138);
}
/* #endregion */
/* #region Adding subscription plan */
.tenant-administrator-adding-subscription-plan-container{
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.212);
}
.tenant-administrator-adding-subscription-plan-progress-container{
    text-align: center;
    padding: 15px 24px;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-adding-subscription-plan-spinner{
    height: 40px;
    width: 40px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-adding-subscription-plan-spinner 1s linear infinite;
}
@keyframes tenant-administrator-adding-subscription-plan-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-adding-subscription-plan-progress-container p{
    margin: 8px 0px;
    cursor: default;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion */
/* #region Edit subscription plan*/
.tenant-administrator-edit-subscription-plan-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0,0.45);
}
.tenant-administrator-edit-subscription-plan-main-container{
    width: 32vw;
    opacity: 0;
    border-radius: 5px;
    background-color: white;
    transform: translateX(-100%);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    animation: tenant-administrator-edit-subscription-plan-main-container-fade-in 1s ease-out forwards;
}
@keyframes tenant-administrator-edit-subscription-plan-main-container-fade-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    80% {
        opacity: 1;
        transform: translateX(5%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.tenant-administrator-edit-subscription-plan-header-container{
    color: white;
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-edit-subscription-plan-header-container h1{
    margin: 0px;
    font-size: 22px;
    font-weight: 600;
}
.tenant-administrator-edit-subscription-plan-header-container p{
    margin: 0px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.tenant-administrator-edit-subscription-plan-body-container{
    position: relative;
    padding: 10px 25px;
    height: 670px;
    overflow: hidden;
}
.tenant-administrator-edit-subscription-plan-navigation-bar{
    border-bottom: 1px solid rgb(219, 219, 219);
}
.tenant-administrator-edit-subscription-plan-navigation-bar button{
    padding: 8px 20px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    color: rgb(70, 70, 70);
    background-color: transparent;
    border-bottom: 2px solid transparent;
    transition: border-bottom-color 0.25s ease;
}
.tenant-administrator-edit-subscription-plan-navigation-bar button.active{
    color: rgba(155, 30, 30, 0.952);
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.tenant-administrator-edit-subscription-plan-details-container,
.tenant-administrator-edit-subscription-plan-visibility-container{
    opacity: 0;
    transform: translateX(-100%);
    transition: opacity 0.1s ease, transform 0.5s ease;
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0;
    pointer-events: none;
}
.tenant-administrator-edit-subscription-plan-details-container.active,
.tenant-administrator-edit-subscription-plan-visibility-container.active{
    opacity: 1;
    transform: translateX(0);
    position: relative;
    pointer-events: auto;
}
.tenant-administrator-edit-subscription-plan-details-container.hidden,
.tenant-administrator-edit-subscription-plan-visibility-container.hidden{
    opacity: 0;
    transform: translateX(100%);
    pointer-events: none;
}
.tenant-administrator-edit-subscription-plan-details-container .components-container{
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-edit-subscription-plan-details-container .components-container:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.tenant-administrator-edit-subscription-plan-details-container .components-container p{
    margin: 0px;
    font-size: 12px;
}
.tenant-administrator-edit-subscription-plan-details-container .components-container span{
    color: red;
}
.tenant-administrator-edit-subscription-plan-details-container .components-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
}
.tenant-administrator-edit-subscription-plan-details-container .components-container select{
    width: 100%;
    margin: 0px;
    border: none;
    outline: none;
    padding: 2px 0px;
    background-color: transparent;
}
.tenant-administrator-edit-subscription-plan-details-container .deactivation-window-entry-container{
    display: grid;
    grid-template-columns: 2fr 1fr;
    margin-top: 2px;
    margin-right: 6px;
}
.tenant-administrator-edit-subscription-plan-details-container .features-title-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
}
.tenant-administrator-edit-subscription-plan-details-container .features-title-container h2{
    margin: 0px;
    font-size: 20px;
    font-weight: 600;
    color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-edit-subscription-plan-details-container .features-title-container img{
    margin: 0px;
    height: 25px;
    cursor: pointer;
}
.tenant-administrator-edit-subscription-plan-details-container .feature-containers{
    padding: 0px 15px;
    height: 20vh;
    overflow-y: auto;
}
.tenant-administrator-edit-subscription-plan-details-container .features-empty-container{
    height: 20vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-edit-subscription-plan-details-container .features-empty-container div{
    padding: 10px;
    border-radius: 10px;
    opacity: 0;
    transform: translateY(-10px);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    animation: tenant-administrator-edit-subscription-features-empty-container-fade-in 1.55s ease forwards;
}
@keyframes tenant-administrator-edit-subscription-features-empty-container-fade-in {
    from{
        opacity: 0;
        transform: translateY(-10px);
    }
    to{
        opacity: 1;
        transform: translateY(0px);
    }
}
.tenant-administrator-edit-subscription-plan-details-container .features-empty-container div p{
    margin: 0px;
    font-size: 15px;
}
.tenant-administrator-edit-subscription-plan-details-container .feature-container{
    display: flex;
    justify-content: space-between;
    margin: 10px 0px;
    padding: 6px 15px;
    border-radius: 4px;
    border: 1px solid rgb(197, 197, 197);
}
.tenant-administrator-edit-subscription-plan-details-container .feature-container.empty{
    border: 1px solid red;
}
.tenant-administrator-edit-subscription-plan-details-container .feature-container.empty:focus-within{
    border: 1px solid rgb(197, 197, 197);
}
.tenant-administrator-edit-subscription-plan-details-container .feature-container p{
    margin: 0px;
}
.tenant-administrator-edit-subscription-plan-details-container .feature-container input{
    width: 80%;
    outline: none;
    border: none;
}
.tenant-administrator-edit-subscription-plan-details-container .feature-container img{
    height: 20px;
    cursor: pointer;
}
.tenant-administrator-edit-subscription-plan-details-container .buttons-container{
    padding: 15px 0px;
    text-align: right;
}
.tenant-administrator-edit-subscription-plan-details-container .cancel-edit-subscription-button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-weight: 600;
    color: rgba(155, 30, 30, 0.952);
    background-color: transparent;
    transition: background-color 0.25s ease;
}
.tenant-administrator-edit-subscription-plan-details-container .cancel-edit-subscription-button:hover{
    background-color: rgb(238, 238, 238);
}
.tenant-administrator-edit-subscription-plan-details-container .edit-subscription-button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-selection-container{
    margin-top: 25px;
    display: flex;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-selection-container input{
    zoom: 1.5;
    cursor: pointer;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-selection-container p{
    font-size: 15px;
    margin-left: 10px;
    cursor: pointer;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container{
    max-height: 0;
    overflow: hidden;
    height: auto;
    margin-top: 12px;
    padding: 4px 20px;
    transition: max-height 1s ease-in-out, padding 1s ease-in-out;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container.active{
    max-height: 40vh;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header{
    margin-bottom: 28px;
    padding: 8px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(201, 201, 201);
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 600;
    color: rgb(43, 43, 43);
    text-align: center;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header button{
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: transparent;
    transition: background-color 0.25s ease;
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header button:hover{
    background-color: rgb(240, 240, 240);
}
.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header button img{
    height: 30px;
}
.tenant-administrator-edit-subscription-plan-fetching-customers-container{
    width: 100%;
    height: 100%;
    text-align: center;
}
.tenant-administrator-edit-subscription-plan-fetching-customers-container div{
    margin-top: 10%;
    width: 20px;
    height: 20px;
    display: inline-block;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: tenant-administrator-edit-subscription-plan-fetching-customers-container-spinner 1s linear infinite;
}
@keyframes tenant-administrator-edit-subscription-plan-fetching-customers-container-spinner {
    0% {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
}
.tenant-administrator-edit-subscription-plan-fetching-customers-container p{
    margin: 4px 0px;
}
.tenant-administrator-edit-subscription-plan-unselected-server-container,
.tenant-administrator-edit-subscription-plan-unavailable-customers-container{
    height: 15vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
}
.tenant-administrator-edit-plan-visibility-customers-table-container{
    height: 25vh;
    overflow: auto;
    margin-bottom: 20px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-edit-plan-visibility-customers-table-container::-webkit-scrollbar{
    width: 5px;
}
.tenant-administrator-edit-plan-visibility-customers-table-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0,0.3);
}
.tenant-administrator-edit-plan-visibility-customers-table-container table{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}
.tenant-administrator-edit-plan-visibility-customers-table-container table th,
.tenant-administrator-edit-plan-visibility-customers-table-container table td{
    text-align: left;
    padding: 4px;
    padding-left: 20px;
    cursor: default;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-edit-plan-visibility-customers-table-container table th{
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: white;
    border-bottom: 1px solid rgb(214, 214, 214);
}
.tenant-administrator-edit-plan-visibility-customers-table-container table th:last-child,
.tenant-administrator-edit-plan-visibility-customers-table-container table td:last-child{
    width: 10%;
}
.tenant-administrator-edit-plan-visibility-customers-table-container table td img{
    height: 20px;
    margin-top: 2px;
    cursor: pointer;
}
.tenant-administrator-edit-subscription-plan-customers-browser{
    position: absolute;
    top: 0;
    left: 0;
    width: 80%;
    height: 30vh;
    border-radius: 5px;
    background-color: rgb(250, 250, 250);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
}
.tenant-administrator-edit-subscription-plan-customers-browser .header .main-header{
    padding: 4px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-edit-subscription-plan-customers-browser .header .main-header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 600;
    color: rgb(51, 51, 51);
}
.tenant-administrator-edit-subscription-plan-customers-browser .header .main-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 400;
}
.tenant-administrator-edit-subscription-plan-customers-browser .header .minor-header{
    padding: 4px 16px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 150px 1fr;
    color: rgb(236, 236, 236);
    background-color: rgb(107, 126, 138);
}
.tenant-administrator-edit-subscription-plan-customers-browser .header .minor-header p{
    margin: 0px;
}
.tenant-administrator-edit-subscription-plan-customers-browser .header .minor-header .customers-title-paragraph{
    margin-left: 15px;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body{
    flex-grow: 1;
    display: grid;
    grid-template-columns: 150px 1fr;
    background-color: white;
    overflow: hidden;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .servers-container{
    height: 100%;
    border-right: 2px solid rgb(218, 218, 218);
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-container{
    padding: 4px 10px;
    cursor: pointer;
    transition: background-color 0.25s ease;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-container:hover{
    background-color: rgba(98, 115, 119, 0.425);
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container{
    height: 100%;
    overflow-y: auto;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.3);
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p{
    margin: 0px;
    padding: 4px 10px;
    cursor: default;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p:hover{
    background-color: rgba(98, 115, 119, 0.425);
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .server-customer-container{
    font-size: 15px;
    cursor: default;
    padding: 4px 10px;
    transition: background-color 0.45s ease;
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .server-customer-container:hover{
    background-color: rgba(98, 115, 119, 0.425);
}
.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .server-customer-container.selected-customer{
    background-color: rgba(74, 121, 74, 0.18)!important;
}
.tenant-administrator-edit-subscription-plan-customers-browser .controls{
    padding: 10px 0px;
    background-color: transparent;
    text-align: right;
}
.tenant-administrator-edit-subscription-plan-customers-browser .controls button{
    border: none;
    cursor: pointer;
    padding: 6px 16px;
    margin: 0px 10px;
    border-radius: 4px;
    color: rgb(236, 236, 236);
    background-color: rgb(107, 126, 138);
}
/* #endregion*/
/* #region Updating subscription plan */
.tenant-administrator-updating-subscription-plan-container{
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.212);
}
.tenant-administrator-updating-subscription-plan-progress-container{
    text-align: center;
    padding: 15px 24px;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-updating-subscription-plan-spinner{
    height: 40px;
    width: 40px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-updating-subscription-plan-spinner 1s linear infinite;
}
@keyframes tenant-administrator-updating-subscription-plan-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-updating-subscription-plan-progress-container p{
    margin: 8px 0px;
    cursor: default;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion*/
/* #region Delete subscription plan*/
.tenant-administrator-delete-subscription-plan-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0,0.45);
}
.tenant-administrator-delete-subscription-plan-main-container{
    position: relative;
    padding: 10px 40px;
    border-radius: 6px;
    background-color: white;
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.tenant-administrator-delete-subscription-plan-main-container h1{
    margin: 25px 0px;
    margin-right: 140px;
    font-size: 24px;
    font-weight: 700;
    color: rgb(30, 30, 33);
}
.tenant-administrator-delete-subscription-plan-main-container p{
    font-size: 15px;
    margin: 30px 0px;
    color: rgb(30, 30, 33);
}
.tenant-administrator-delete-subscription-plan-buttons-container{
    margin: 20px 0px;
    text-align: right;
}
.tenant-administrator-delete-subscription-plan-buttons-container button{
    border: none;
    cursor: pointer;
    margin-left: 15px;
    padding: 12px 20px;
    border-radius: 4px;
    color: white;
    font-size: 15px;
    font-weight: 700;
}
.tenant-administrator-delete-subscription-plan-buttons-container .cancel-delete-button{
    background-color: rgb(54, 91, 133);
}
.tenant-administrator-delete-subscription-plan-buttons-container .delete-button{
    background-color: rgb(172, 27, 24);
}
.tenant-administrator-delete-subscription-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-delete-subscription-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-delete-subscription-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-delete-subscription-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/* #endregion*/
/* #region deleting subscription plan */
.tenant-administrator-deleting-subscription-plan-container{
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.212);
}
.tenant-administrator-deleting-subscription-plan-progress-container{
    text-align: center;
    padding: 15px 24px;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-deleting-subscription-plan-spinner{
    height: 40px;
    width: 40px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-deleting-subscription-plan-spinner 1s linear infinite;
}
@keyframes tenant-administrator-deleting-subscription-plan-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-deleting-subscription-plan-progress-container p{
    margin: 8px 0px;
    cursor: default;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion*/
/* #region subscription plans window */
.tenant-administrator-subscription-plans-page-layout{
    height: 90%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr;
}
.tenant-administrator-subscription-plans-parent-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-subscription-plans-container{
    width: 90%;
    height: 85%;
    padding: 2% 3%;
    border-radius: 5px;
    position: relative;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-subscription-plans-header-container{
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-subscription-plans-header-container h2{
    font-weight: lighter;
    color: rgb(90, 90, 90);
}
.tenant-administrator-subscription-plans-header-controls button{
    border: none;
    border-radius: 50%;
    padding: 5px 8px;
    cursor: pointer;
    background-color: transparent;
    transition: background-color 0.25s ease;
}
.tenant-administrator-subscription-plans-header-controls button:hover{
    background-color: rgb(221, 221, 221);
}
.tenant-administrator-subscription-plans-header-controls img{
    height: 25px;
}
.tenant-administrator-subscription-plans-loading-container{
    margin-top: 20vh;
    text-align: center;
}
.tenant-administrator-subscription-plans-loading-container div{
    display: inline-block;
    height: 40px;
    width: 40px;
    border: 2px solid brown;
    border-radius: 50%;
    border-top-color: transparent;
    animation: tenant-administrator-subscription-plans-loading-container-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-subscription-plans-loading-container-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-subscription-plans-loading-container p{
    cursor: default;
    color: rgb(48, 48, 48);
    font-size: 16px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-subscription-plans-grid-container{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    column-gap: 10px;
    row-gap: 10px;
    max-height: 60vh;
    overflow: auto;
    padding: 25px 10px;
}
.tenant-administrator-subscription-plans-subscription-card{
    position: relative;
    padding: 10px 25px;
    border-radius: 1vh;
    padding-bottom: 75px;
    box-shadow: 0px 4px 12px rgba(50, 50, 50, 0.15);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-subscription-plans-subscription-card:hover{
    transform: translateY(-2px);
    box-shadow: 0px 6px 16px rgba(50, 50, 50, 0.2);
    transition: transform 0.25s ease-out, box-shadow 0.25s ease-out;
}
.tenant-administrator-subscription-plans-subscription-card .title-container{
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-subscription-plans-subscription-card .title-container p{
    margin: 0px;
    font-size: 20px;
    font-weight: 600;
    color: rgb(75, 75, 75);
    letter-spacing: 0.5px;
}
.tenant-administrator-subscription-plans-subscription-card .title-container .edit-subscription-button{
    border: none;
    border-radius: 50px;
    padding: 3px 6px;
    background-color: rgba(233, 77, 30, 0.953);
}
.tenant-administrator-subscription-plans-subscription-card .title-container .delete-subscription-button{
    border: none;
    margin-left: 8px;
    padding: 4px 7px;
    border-radius: 50%;
    background-color: transparent;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-subscription-plans-subscription-card .title-container img{
    margin-top: 2px;
    height: 16px;
    cursor: pointer;
}
.tenant-administrator-subscription-plans-subscription-card .price-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-subscription-plans-subscription-card .price-container span{
    color: rgb(245, 78, 0);
}
.tenant-administrator-subscription-plans-subscription-card .price-container .currency-span{
    font-size: 14px;
    font-weight: 600;
    color: black;
}
.tenant-administrator-subscription-plans-subscription-card .price-container strong{
    margin: 0px 4px;
    font-size: 32px;
    font-weight: 600;
    color: green;
}
.tenant-administrator-subscription-plans-subscription-card .billing-cycle-container{
    padding: 10px 0px;
}
.tenant-administrator-subscription-plans-subscription-card .billing-cycle-container strong{
    color: rgb(65, 65, 65);
}
.tenant-administrator-subscription-plans-subscription-card .features-container{
    margin-top: 10px;
    padding-top: 5px;
    margin-bottom: 5px;
    border-top: solid 1px rgb(207, 207, 207);
}
.tenant-administrator-subscription-plans-subscription-card .feature span{
    margin: 0px 4px;
}
.tenant-administrator-subscription-plans-subscription-card .feature{
    margin: 4px 0px;
    font-size: 14px;
    color: rgb(49, 49, 49);
}
.tenant-administrator-subscription-plans-subscription-card .subscribe-button-container{
    position: absolute;
    bottom: 10px;
    left: 0px;
    width: 100%;
    box-sizing: border-box;
    padding: 15px 0px;
    display: flex;
    justify-content: center;
}
.tenant-administrator-subscription-plans-subscription-card .subscribe-button-container button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 20px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(161, 161, 161, 0.952);
    transition: background-color 0.25s ease;
}
.tenant-administrator-subscription-plans-subscription-card .subscribe-button-container button:hover{
    background-color: rgba(187, 187, 187, 0.952);
}
/* #endregion */`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/SubscriptionPlans/SubscriptionPlans.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+CAA+C;AACnD;AACA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,4DAA4D;IAC5D,iGAAiG;AACrG;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;AACA;;IAEI,UAAU;IACV,4BAA4B;IAC5B,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,OAAO;IACP,oBAAoB;AACxB;AACA;;IAEI,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;IAEI,UAAU;IACV,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,4BAA4B;IAC5B,2CAA2C;IAC3C,qGAAqG;AACzG;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,aAAa;IACb,YAAY;AAChB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,6BAA6B;IAC7B,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,6DAA6D;AACjE;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,6GAA6G;AACjH;AACA;IACI,IAAI,uBAAuB,CAAC;IAC5B,MAAM,yBAAyB,CAAC;AACpC;AACA;IACI,eAAe;AACnB;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,uBAAuB;IACvB,2CAA2C;AAC/C;AACA;;IAEI,UAAU;AACd;AACA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,gCAAgC;IAChC,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,0CAA0C;AAC9C;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,uCAAuC;AAC3C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,uCAAuC;AAC3C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,mDAAmD;AACvD;AACA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,oCAAoC;AACxC;AACA,eAAe;AACf,qCAAqC;AACrC;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,mFAAmF;AACvF;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,eAAe;IACf,4DAA4D;AAChE;AACA,eAAe;AACf,kCAAkC;AAClC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,4DAA4D;IAC5D,kGAAkG;AACtG;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;AACA;;IAEI,UAAU;IACV,4BAA4B;IAC5B,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,OAAO;IACP,oBAAoB;AACxB;AACA;;IAEI,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;IAEI,UAAU;IACV,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,4BAA4B;IAC5B,2CAA2C;IAC3C,sGAAsG;AAC1G;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,aAAa;IACb,YAAY;AAChB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,6BAA6B;IAC7B,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,6DAA6D;AACjE;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,8GAA8G;AAClH;AACA;IACI,IAAI,uBAAuB,CAAC;IAC5B,MAAM,yBAAyB,CAAC;AACpC;AACA;IACI,eAAe;AACnB;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,uBAAuB;IACvB,2CAA2C;AAC/C;AACA;;IAEI,UAAU;AACd;AACA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,gCAAgC;IAChC,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,0CAA0C;AAC9C;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,uCAAuC;AAC3C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,uCAAuC;AAC3C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,mDAAmD;AACvD;AACA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,oCAAoC;AACxC;AACA,cAAc;AACd,uCAAuC;AACvC;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,qFAAqF;AACzF;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,eAAe;IACf,4DAA4D;AAChE;AACA,cAAc;AACd,oCAAoC;AACpC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,yEAAyE;AAC7E;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,cAAc;AACd,uCAAuC;AACvC;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,qFAAqF;AACzF;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,eAAe;IACf,4DAA4D;AAChE;AACA,cAAc;AACd,sCAAsC;AACtC;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;AAC1C;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,iGAAiG;AACrG;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,+CAA+C;IAC/C,4DAA4D;AAChE;AACA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,+DAA+D;AACnE;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,4CAA4C;IAC5C,uCAAuC;AAC3C;AACA;IACI,4CAA4C;AAChD;AACA,eAAe","sourcesContent":[".tenant-administrator-subscription-plans-page{\r\n    position: relative;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    height: 100vh;\r\n    box-sizing: border-box;\r\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n}\r\n/* #region Add subscription plan*/\r\n.tenant-administrator-add-subscription-plan-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0,0.45);\r\n}\r\n.tenant-administrator-add-subscription-plan-main-container{\r\n    position: relative;\r\n    width: 32vw;\r\n    opacity: 0;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    transform: translateX(-100%);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    animation: tenant-administrator-add-subscription-plan-main-container-fade-in 1s ease-out forwards;\r\n}\r\n@keyframes tenant-administrator-add-subscription-plan-main-container-fade-in {\r\n    from{\r\n        opacity: 0;\r\n        transform: translateX(-100%);\r\n    }\r\n    80% {\r\n        opacity: 1;\r\n        transform: translateX(5%);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n.tenant-administrator-add-subscription-plan-header-container{\r\n    color: white;\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n    justify-content: space-between;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-add-subscription-plan-header-container h1{\r\n    margin: 0px;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.tenant-administrator-add-subscription-plan-header-container p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-add-subscription-plan-body-container{\r\n    position: relative;\r\n    padding: 10px 25px;\r\n    height: 670px;\r\n    overflow: hidden;\r\n}\r\n.tenant-administrator-add-subscription-plan-navigation-bar{\r\n    border-bottom: 1px solid rgb(219, 219, 219);\r\n}\r\n.tenant-administrator-add-subscription-plan-navigation-bar button{\r\n    padding: 8px 20px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: rgb(70, 70, 70);\r\n    background-color: transparent;\r\n    border-bottom: 2px solid transparent;\r\n    transition: border-bottom-color 0.25s ease;\r\n}\r\n.tenant-administrator-add-subscription-plan-navigation-bar button.active{\r\n    color: rgba(155, 30, 30, 0.952);\r\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container,\r\n.tenant-administrator-add-subscription-plan-visibility-container{\r\n    opacity: 0;\r\n    transform: translateX(-100%);\r\n    transition: opacity 0.1s ease, transform 0.5s ease;\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 0px;\r\n    left: 0;\r\n    pointer-events: none;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container.active,\r\n.tenant-administrator-add-subscription-plan-visibility-container.active{\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    position: relative;\r\n    pointer-events: auto;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container.hidden,\r\n.tenant-administrator-add-subscription-plan-visibility-container.hidden{\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n    pointer-events: none;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .components-container{\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid gray;\r\n    border-radius: 2px 2px 0px 0px;\r\n    background-color: rgba(222, 229, 233,0.6);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .components-container:focus-within{\r\n    border-bottom: 2px solid rgb(119, 12, 12);\r\n    background-color: rgb(221, 232, 238);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .components-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .components-container span{\r\n    color: red;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .components-container input{\r\n    width: 100%;\r\n    outline: none;\r\n    border: none;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .components-container select{\r\n    width: 100%;\r\n    margin: 0px;\r\n    border: none;\r\n    outline: none;\r\n    padding: 2px 0px;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .deactivation-window-entry-container{\r\n    display: grid;\r\n    grid-template-columns: 2fr 1fr;\r\n    margin-top: 2px;\r\n    margin-right: 6px;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .features-title-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0px 10px;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .features-title-container h2{\r\n    margin: 0px;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .features-title-container img{\r\n    margin: 0px;\r\n    height: 25px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-containers{\r\n    padding: 0px 15px;\r\n    height: 20vh;\r\n    overflow-y: auto;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .features-empty-container{\r\n    height: 20vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .features-empty-container div{\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\r\n    animation: tenant-administrator-add-subscription-features-empty-container-fade-in 1.55s ease forwards;\r\n}\r\n@keyframes tenant-administrator-add-subscription-features-empty-container-fade-in {\r\n    from{\r\n        opacity: 0;\r\n        transform: translateY(-10px);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .features-empty-container div p{\r\n    margin: 0px;\r\n    font-size: 15px;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-container{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 10px 0px;\r\n    padding: 6px 15px;\r\n    border-radius: 4px;\r\n    border: 1px solid rgb(197, 197, 197);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-container.empty{\r\n    border: 1px solid red;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-container.empty:focus-within{\r\n    border: 1px solid rgb(197, 197, 197);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-container p{\r\n    margin: 0px;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-container input{\r\n    width: 80%;\r\n    outline: none;\r\n    border: none;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .feature-container img{\r\n    height: 20px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .buttons-container{\r\n    padding: 15px 0px;\r\n    text-align: right;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .cancel-add-subscription-button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    background-color: transparent;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .cancel-add-subscription-button:hover{\r\n    background-color: rgb(238, 238, 238);\r\n}\r\n.tenant-administrator-add-subscription-plan-details-container .add-subscription-button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.2s ease;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-selection-container{\r\n    margin-top: 25px;\r\n    display: flex;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-selection-container input{\r\n    zoom: 1.5;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-selection-container p{\r\n    font-size: 15px;\r\n    margin-left: 10px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container{\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    height: auto;\r\n    margin-top: 12px;\r\n    padding: 4px 20px;\r\n    transition: max-height 1s ease-in-out, padding 1s ease-in-out;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container.active{\r\n    max-height: 40vh;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header{\r\n    margin-bottom: 28px;\r\n    padding: 8px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid rgb(201, 201, 201);\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: rgb(43, 43, 43);\r\n    text-align: center;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 2px 4px;\r\n    border-radius: 50%;\r\n    margin-right: 10px;\r\n    background-color: transparent;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header button:hover{\r\n    background-color: rgb(240, 240, 240);\r\n}\r\n.tenant-administrator-add-subscription-plan-visibility-container .visibility-customers-container-header button img{\r\n    height: 30px;\r\n}\r\n.tenant-administrator-add-subscription-plan-fetching-customers-container{\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n}\r\n.tenant-administrator-add-subscription-plan-fetching-customers-container div{\r\n    margin-top: 10%;\r\n    width: 20px;\r\n    height: 20px;\r\n    display: inline-block;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top: 2px solid transparent;\r\n    border-radius: 50%;\r\n    animation: tenant-administrator-add-subscription-plan-fetching-customers-container-spinner 1s linear infinite;\r\n}\r\n@keyframes tenant-administrator-add-subscription-plan-fetching-customers-container-spinner {\r\n    0% {transform: rotate(0deg);}\r\n    100% {transform: rotate(360deg);}\r\n}\r\n.tenant-administrator-add-subscription-plan-fetching-customers-container p{\r\n    margin: 4px 0px;\r\n}\r\n.tenant-administrator-add-subscription-plan-unselected-server-container,\r\n.tenant-administrator-add-subscription-plan-unavailable-customers-container{\r\n    height: 15vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 15px;\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container{\r\n    height: 25vh;\r\n    overflow: auto;\r\n    margin-bottom: 20px;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container::-webkit-scrollbar{\r\n    width: 5px;\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0,0.3);\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container table{\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    border-collapse: collapse;\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container table th,\r\n.tenant-administrator-new-plan-visibility-customers-table-container table td{\r\n    text-align: left;\r\n    padding: 4px;\r\n    padding-left: 20px;\r\n    cursor: default;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container table th{\r\n    font-weight: 600;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1;\r\n    background-color: white;\r\n    border-bottom: 1px solid rgb(214, 214, 214);\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container table th:last-child,\r\n.tenant-administrator-new-plan-visibility-customers-table-container table td:last-child{\r\n    width: 10%;\r\n}\r\n.tenant-administrator-new-plan-visibility-customers-table-container table td img{\r\n    height: 20px;\r\n    margin-top: 2px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 80%;\r\n    height: 30vh;\r\n    border-radius: 5px;\r\n    background-color: rgb(250, 250, 250);\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .header .main-header{\r\n    padding: 4px 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .header .main-header h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: rgb(51, 51, 51);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .header .main-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .header .minor-header{\r\n    padding: 4px 16px;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: 150px 1fr;\r\n    color: rgb(236, 236, 236);\r\n    background-color: rgb(107, 126, 138);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .header .minor-header p{\r\n    margin: 0px;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .header .minor-header .customers-title-paragraph{\r\n    margin-left: 15px;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body{\r\n    flex-grow: 1;\r\n    display: grid;\r\n    grid-template-columns: 150px 1fr;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .servers-container{\r\n    height: 100%;\r\n    border-right: 2px solid rgb(218, 218, 218);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-container{\r\n    padding: 4px 10px;\r\n    cursor: pointer;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-container:hover{\r\n    background-color: rgba(98, 115, 119, 0.425);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container{\r\n    height: 100%;\r\n    overflow-y: auto;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p{\r\n    margin: 0px;\r\n    padding: 4px 10px;\r\n    cursor: default;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p:hover{\r\n    background-color: rgba(98, 115, 119, 0.425);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .server-customer-container{\r\n    font-size: 15px;\r\n    cursor: default;\r\n    padding: 4px 10px;\r\n    transition: background-color 0.45s ease;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .server-customer-container:hover{\r\n    background-color: rgba(98, 115, 119, 0.425);\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .body .server-customers-container .server-customer-container.selected-customer{\r\n    background-color: rgba(74, 121, 74, 0.18)!important;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .controls{\r\n    padding: 10px 0px;\r\n    background-color: transparent;\r\n    text-align: right;\r\n}\r\n.tenant-administrator-add-subscription-plan-customers-browser .controls button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 6px 16px;\r\n    margin: 0px 10px;\r\n    border-radius: 4px;\r\n    color: rgb(236, 236, 236);\r\n    background-color: rgb(107, 126, 138);\r\n}\r\n/* #endregion */\r\n/* #region Adding subscription plan */\r\n.tenant-administrator-adding-subscription-plan-container{\r\n    position: absolute;\r\n    z-index: 10;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.212);\r\n}\r\n.tenant-administrator-adding-subscription-plan-progress-container{\r\n    text-align: center;\r\n    padding: 15px 24px;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-adding-subscription-plan-spinner{\r\n    height: 40px;\r\n    width: 40px;\r\n    display: inline-block;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top-color: transparent;\r\n    animation: tenant-administrator-adding-subscription-plan-spinner 1s linear infinite;\r\n}\r\n@keyframes tenant-administrator-adding-subscription-plan-spinner {\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.tenant-administrator-adding-subscription-plan-progress-container p{\r\n    margin: 8px 0px;\r\n    cursor: default;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n/* #endregion */\r\n/* #region Edit subscription plan*/\r\n.tenant-administrator-edit-subscription-plan-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0,0.45);\r\n}\r\n.tenant-administrator-edit-subscription-plan-main-container{\r\n    width: 32vw;\r\n    opacity: 0;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    transform: translateX(-100%);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    animation: tenant-administrator-edit-subscription-plan-main-container-fade-in 1s ease-out forwards;\r\n}\r\n@keyframes tenant-administrator-edit-subscription-plan-main-container-fade-in {\r\n    from{\r\n        opacity: 0;\r\n        transform: translateX(-100%);\r\n    }\r\n    80% {\r\n        opacity: 1;\r\n        transform: translateX(5%);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n.tenant-administrator-edit-subscription-plan-header-container{\r\n    color: white;\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n    justify-content: space-between;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-edit-subscription-plan-header-container h1{\r\n    margin: 0px;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.tenant-administrator-edit-subscription-plan-header-container p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-edit-subscription-plan-body-container{\r\n    position: relative;\r\n    padding: 10px 25px;\r\n    height: 670px;\r\n    overflow: hidden;\r\n}\r\n.tenant-administrator-edit-subscription-plan-navigation-bar{\r\n    border-bottom: 1px solid rgb(219, 219, 219);\r\n}\r\n.tenant-administrator-edit-subscription-plan-navigation-bar button{\r\n    padding: 8px 20px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: rgb(70, 70, 70);\r\n    background-color: transparent;\r\n    border-bottom: 2px solid transparent;\r\n    transition: border-bottom-color 0.25s ease;\r\n}\r\n.tenant-administrator-edit-subscription-plan-navigation-bar button.active{\r\n    color: rgba(155, 30, 30, 0.952);\r\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container,\r\n.tenant-administrator-edit-subscription-plan-visibility-container{\r\n    opacity: 0;\r\n    transform: translateX(-100%);\r\n    transition: opacity 0.1s ease, transform 0.5s ease;\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 0px;\r\n    left: 0;\r\n    pointer-events: none;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container.active,\r\n.tenant-administrator-edit-subscription-plan-visibility-container.active{\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    position: relative;\r\n    pointer-events: auto;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container.hidden,\r\n.tenant-administrator-edit-subscription-plan-visibility-container.hidden{\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n    pointer-events: none;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .components-container{\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid gray;\r\n    border-radius: 2px 2px 0px 0px;\r\n    background-color: rgba(222, 229, 233,0.6);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .components-container:focus-within{\r\n    border-bottom: 2px solid rgb(119, 12, 12);\r\n    background-color: rgb(221, 232, 238);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .components-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .components-container span{\r\n    color: red;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .components-container input{\r\n    width: 100%;\r\n    outline: none;\r\n    border: none;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .components-container select{\r\n    width: 100%;\r\n    margin: 0px;\r\n    border: none;\r\n    outline: none;\r\n    padding: 2px 0px;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .deactivation-window-entry-container{\r\n    display: grid;\r\n    grid-template-columns: 2fr 1fr;\r\n    margin-top: 2px;\r\n    margin-right: 6px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .features-title-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0px 10px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .features-title-container h2{\r\n    margin: 0px;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .features-title-container img{\r\n    margin: 0px;\r\n    height: 25px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-containers{\r\n    padding: 0px 15px;\r\n    height: 20vh;\r\n    overflow-y: auto;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .features-empty-container{\r\n    height: 20vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .features-empty-container div{\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\r\n    animation: tenant-administrator-edit-subscription-features-empty-container-fade-in 1.55s ease forwards;\r\n}\r\n@keyframes tenant-administrator-edit-subscription-features-empty-container-fade-in {\r\n    from{\r\n        opacity: 0;\r\n        transform: translateY(-10px);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .features-empty-container div p{\r\n    margin: 0px;\r\n    font-size: 15px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-container{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 10px 0px;\r\n    padding: 6px 15px;\r\n    border-radius: 4px;\r\n    border: 1px solid rgb(197, 197, 197);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-container.empty{\r\n    border: 1px solid red;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-container.empty:focus-within{\r\n    border: 1px solid rgb(197, 197, 197);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-container p{\r\n    margin: 0px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-container input{\r\n    width: 80%;\r\n    outline: none;\r\n    border: none;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .feature-container img{\r\n    height: 20px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .buttons-container{\r\n    padding: 15px 0px;\r\n    text-align: right;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .cancel-edit-subscription-button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    background-color: transparent;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .cancel-edit-subscription-button:hover{\r\n    background-color: rgb(238, 238, 238);\r\n}\r\n.tenant-administrator-edit-subscription-plan-details-container .edit-subscription-button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.2s ease;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-selection-container{\r\n    margin-top: 25px;\r\n    display: flex;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-selection-container input{\r\n    zoom: 1.5;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-selection-container p{\r\n    font-size: 15px;\r\n    margin-left: 10px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container{\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    height: auto;\r\n    margin-top: 12px;\r\n    padding: 4px 20px;\r\n    transition: max-height 1s ease-in-out, padding 1s ease-in-out;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container.active{\r\n    max-height: 40vh;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header{\r\n    margin-bottom: 28px;\r\n    padding: 8px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid rgb(201, 201, 201);\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: rgb(43, 43, 43);\r\n    text-align: center;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 2px 4px;\r\n    border-radius: 50%;\r\n    margin-right: 10px;\r\n    background-color: transparent;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header button:hover{\r\n    background-color: rgb(240, 240, 240);\r\n}\r\n.tenant-administrator-edit-subscription-plan-visibility-container .visibility-customers-container-header button img{\r\n    height: 30px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-fetching-customers-container{\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n}\r\n.tenant-administrator-edit-subscription-plan-fetching-customers-container div{\r\n    margin-top: 10%;\r\n    width: 20px;\r\n    height: 20px;\r\n    display: inline-block;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top: 2px solid transparent;\r\n    border-radius: 50%;\r\n    animation: tenant-administrator-edit-subscription-plan-fetching-customers-container-spinner 1s linear infinite;\r\n}\r\n@keyframes tenant-administrator-edit-subscription-plan-fetching-customers-container-spinner {\r\n    0% {transform: rotate(0deg);}\r\n    100% {transform: rotate(360deg);}\r\n}\r\n.tenant-administrator-edit-subscription-plan-fetching-customers-container p{\r\n    margin: 4px 0px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-unselected-server-container,\r\n.tenant-administrator-edit-subscription-plan-unavailable-customers-container{\r\n    height: 15vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 15px;\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container{\r\n    height: 25vh;\r\n    overflow: auto;\r\n    margin-bottom: 20px;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container::-webkit-scrollbar{\r\n    width: 5px;\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0,0.3);\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table{\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    border-collapse: collapse;\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table th,\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table td{\r\n    text-align: left;\r\n    padding: 4px;\r\n    padding-left: 20px;\r\n    cursor: default;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table th{\r\n    font-weight: 600;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1;\r\n    background-color: white;\r\n    border-bottom: 1px solid rgb(214, 214, 214);\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table th:last-child,\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table td:last-child{\r\n    width: 10%;\r\n}\r\n.tenant-administrator-edit-plan-visibility-customers-table-container table td img{\r\n    height: 20px;\r\n    margin-top: 2px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 80%;\r\n    height: 30vh;\r\n    border-radius: 5px;\r\n    background-color: rgb(250, 250, 250);\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .header .main-header{\r\n    padding: 4px 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .header .main-header h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: rgb(51, 51, 51);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .header .main-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .header .minor-header{\r\n    padding: 4px 16px;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: 150px 1fr;\r\n    color: rgb(236, 236, 236);\r\n    background-color: rgb(107, 126, 138);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .header .minor-header p{\r\n    margin: 0px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .header .minor-header .customers-title-paragraph{\r\n    margin-left: 15px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body{\r\n    flex-grow: 1;\r\n    display: grid;\r\n    grid-template-columns: 150px 1fr;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .servers-container{\r\n    height: 100%;\r\n    border-right: 2px solid rgb(218, 218, 218);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-container{\r\n    padding: 4px 10px;\r\n    cursor: pointer;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-container:hover{\r\n    background-color: rgba(98, 115, 119, 0.425);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container{\r\n    height: 100%;\r\n    overflow-y: auto;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p{\r\n    margin: 0px;\r\n    padding: 4px 10px;\r\n    cursor: default;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .all-customers-all-servers p:hover{\r\n    background-color: rgba(98, 115, 119, 0.425);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .server-customer-container{\r\n    font-size: 15px;\r\n    cursor: default;\r\n    padding: 4px 10px;\r\n    transition: background-color 0.45s ease;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .server-customer-container:hover{\r\n    background-color: rgba(98, 115, 119, 0.425);\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .body .server-customers-container .server-customer-container.selected-customer{\r\n    background-color: rgba(74, 121, 74, 0.18)!important;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .controls{\r\n    padding: 10px 0px;\r\n    background-color: transparent;\r\n    text-align: right;\r\n}\r\n.tenant-administrator-edit-subscription-plan-customers-browser .controls button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 6px 16px;\r\n    margin: 0px 10px;\r\n    border-radius: 4px;\r\n    color: rgb(236, 236, 236);\r\n    background-color: rgb(107, 126, 138);\r\n}\r\n/* #endregion*/\r\n/* #region Updating subscription plan */\r\n.tenant-administrator-updating-subscription-plan-container{\r\n    position: absolute;\r\n    z-index: 10;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.212);\r\n}\r\n.tenant-administrator-updating-subscription-plan-progress-container{\r\n    text-align: center;\r\n    padding: 15px 24px;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-updating-subscription-plan-spinner{\r\n    height: 40px;\r\n    width: 40px;\r\n    display: inline-block;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top-color: transparent;\r\n    animation: tenant-administrator-updating-subscription-plan-spinner 1s linear infinite;\r\n}\r\n@keyframes tenant-administrator-updating-subscription-plan-spinner {\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.tenant-administrator-updating-subscription-plan-progress-container p{\r\n    margin: 8px 0px;\r\n    cursor: default;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n/* #endregion*/\r\n/* #region Delete subscription plan*/\r\n.tenant-administrator-delete-subscription-plan-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0,0.45);\r\n}\r\n.tenant-administrator-delete-subscription-plan-main-container{\r\n    position: relative;\r\n    padding: 10px 40px;\r\n    border-radius: 6px;\r\n    background-color: white;\r\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\r\n}\r\n.tenant-administrator-delete-subscription-plan-main-container h1{\r\n    margin: 25px 0px;\r\n    margin-right: 140px;\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: rgb(30, 30, 33);\r\n}\r\n.tenant-administrator-delete-subscription-plan-main-container p{\r\n    font-size: 15px;\r\n    margin: 30px 0px;\r\n    color: rgb(30, 30, 33);\r\n}\r\n.tenant-administrator-delete-subscription-plan-buttons-container{\r\n    margin: 20px 0px;\r\n    text-align: right;\r\n}\r\n.tenant-administrator-delete-subscription-plan-buttons-container button{\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-left: 15px;\r\n    padding: 12px 20px;\r\n    border-radius: 4px;\r\n    color: white;\r\n    font-size: 15px;\r\n    font-weight: 700;\r\n}\r\n.tenant-administrator-delete-subscription-plan-buttons-container .cancel-delete-button{\r\n    background-color: rgb(54, 91, 133);\r\n}\r\n.tenant-administrator-delete-subscription-plan-buttons-container .delete-button{\r\n    background-color: rgb(172, 27, 24);\r\n}\r\n.tenant-administrator-delete-subscription-escape-button-container{\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -60px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-delete-subscription-escape-button-container:hover button{\r\n    color: rgb(96, 96, 96);\r\n}\r\n.tenant-administrator-delete-subscription-escape-button-container button{\r\n    border: none;\r\n    font-size: 20px;\r\n    padding: 10px 16px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    background-color: white;\r\n    color: rgb(175, 175, 175);\r\n    transition: color 0.25s ease;\r\n}\r\n.tenant-administrator-delete-subscription-escape-button-container p{\r\n    margin: 5px 0px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: 900;\r\n    cursor: pointer;\r\n    color: rgb(240, 240, 240);\r\n}\r\n/* #endregion*/\r\n/* #region deleting subscription plan */\r\n.tenant-administrator-deleting-subscription-plan-container{\r\n    position: absolute;\r\n    z-index: 10;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.212);\r\n}\r\n.tenant-administrator-deleting-subscription-plan-progress-container{\r\n    text-align: center;\r\n    padding: 15px 24px;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-deleting-subscription-plan-spinner{\r\n    height: 40px;\r\n    width: 40px;\r\n    display: inline-block;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top-color: transparent;\r\n    animation: tenant-administrator-deleting-subscription-plan-spinner 1s linear infinite;\r\n}\r\n@keyframes tenant-administrator-deleting-subscription-plan-spinner {\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.tenant-administrator-deleting-subscription-plan-progress-container p{\r\n    margin: 8px 0px;\r\n    cursor: default;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n/* #endregion*/\r\n/* #region subscription plans window */\r\n.tenant-administrator-subscription-plans-page-layout{\r\n    height: 90%;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n}\r\n.tenant-administrator-subscription-plans-parent-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-subscription-plans-container{\r\n    width: 90%;\r\n    height: 85%;\r\n    padding: 2% 3%;\r\n    border-radius: 5px;\r\n    position: relative;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-subscription-plans-header-container{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-subscription-plans-header-container h2{\r\n    font-weight: lighter;\r\n    color: rgb(90, 90, 90);\r\n}\r\n.tenant-administrator-subscription-plans-header-controls button{\r\n    border: none;\r\n    border-radius: 50%;\r\n    padding: 5px 8px;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-subscription-plans-header-controls button:hover{\r\n    background-color: rgb(221, 221, 221);\r\n}\r\n.tenant-administrator-subscription-plans-header-controls img{\r\n    height: 25px;\r\n}\r\n.tenant-administrator-subscription-plans-loading-container{\r\n    margin-top: 20vh;\r\n    text-align: center;\r\n}\r\n.tenant-administrator-subscription-plans-loading-container div{\r\n    display: inline-block;\r\n    height: 40px;\r\n    width: 40px;\r\n    border: 2px solid brown;\r\n    border-radius: 50%;\r\n    border-top-color: transparent;\r\n    animation: tenant-administrator-subscription-plans-loading-container-spinner 0.8s linear infinite;\r\n}\r\n@keyframes tenant-administrator-subscription-plans-loading-container-spinner {\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.tenant-administrator-subscription-plans-loading-container p{\r\n    cursor: default;\r\n    color: rgb(48, 48, 48);\r\n    font-size: 16px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-subscription-plans-grid-container{\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    column-gap: 10px;\r\n    row-gap: 10px;\r\n    max-height: 60vh;\r\n    overflow: auto;\r\n    padding: 25px 10px;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card{\r\n    position: relative;\r\n    padding: 10px 25px;\r\n    border-radius: 1vh;\r\n    padding-bottom: 75px;\r\n    box-shadow: 0px 4px 12px rgba(50, 50, 50, 0.15);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card:hover{\r\n    transform: translateY(-2px);\r\n    box-shadow: 0px 6px 16px rgba(50, 50, 50, 0.2);\r\n    transition: transform 0.25s ease-out, box-shadow 0.25s ease-out;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .title-container{\r\n    margin-bottom: 8px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .title-container p{\r\n    margin: 0px;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: rgb(75, 75, 75);\r\n    letter-spacing: 0.5px;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .title-container .edit-subscription-button{\r\n    border: none;\r\n    border-radius: 50px;\r\n    padding: 3px 6px;\r\n    background-color: rgba(233, 77, 30, 0.953);\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .title-container .delete-subscription-button{\r\n    border: none;\r\n    margin-left: 8px;\r\n    padding: 4px 7px;\r\n    border-radius: 50%;\r\n    background-color: transparent;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .title-container img{\r\n    margin-top: 2px;\r\n    height: 16px;\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .price-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .price-container span{\r\n    color: rgb(245, 78, 0);\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .price-container .currency-span{\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: black;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .price-container strong{\r\n    margin: 0px 4px;\r\n    font-size: 32px;\r\n    font-weight: 600;\r\n    color: green;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .billing-cycle-container{\r\n    padding: 10px 0px;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .billing-cycle-container strong{\r\n    color: rgb(65, 65, 65);\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .features-container{\r\n    margin-top: 10px;\r\n    padding-top: 5px;\r\n    margin-bottom: 5px;\r\n    border-top: solid 1px rgb(207, 207, 207);\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .feature span{\r\n    margin: 0px 4px;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .feature{\r\n    margin: 4px 0px;\r\n    font-size: 14px;\r\n    color: rgb(49, 49, 49);\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .subscribe-button-container{\r\n    position: absolute;\r\n    bottom: 10px;\r\n    left: 0px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    padding: 15px 0px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .subscribe-button-container button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 20px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(161, 161, 161, 0.952);\r\n    transition: background-color 0.25s ease;\r\n}\r\n.tenant-administrator-subscription-plans-subscription-card .subscribe-button-container button:hover{\r\n    background-color: rgba(187, 187, 187, 0.952);\r\n}\r\n/* #endregion */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
